module.exports = __webpack_public_path__ + "img/snowflake-hrnek-1.0d19913e.png";